import React from "react";
import { useDevice, useTheme } from "../../../common/hooks";
import Star from "../../icons/Star";
import "./drawer.css";

export default function StarsRow(props) {
  const { title = "level", value = 4 } = props;
  const { theme } = useTheme();
  const { isDesktop } = useDevice();

  const width = isDesktop ? 40 : 20;
  const height = isDesktop ? 40 : 20;

  return (
    <div className="star-row">
      <div style={{ color: theme.primaryText }}>{title}</div>
      <div className="stars">
        <Star isFilled={value >= 1} index={1} width={width} height={height} />
        <Star isFilled={value >= 2} index={2} width={width} height={height} />
        <Star isFilled={value >= 3} index={3} width={width} height={height} />
        <Star isFilled={value >= 4} index={4} width={width} height={height} />
        <Star isFilled={value >= 5} index={5} width={width} height={height} />
      </div>
    </div>
  );
}
